import { PlpSitemap, PlpSitemapLinker } from "./plp-sitemap";
import { useMemo } from "react";

export function useSitemapLinker(pathname: string): PlpSitemapLinker {
  return useMemo(() => PlpSitemap.linkTo(pathname), [pathname]);
}
